<template>
  <div class="box has-border-light">
    <div class="px-2">
      <div class="is-flex is-justify-content-space-between">
        <div>
          <p class="is-size-2 has-text-weight-semibold">{{ billingPlanForm.name }}</p>
          <p class="is-size-3 has-text-weight-medium">{{ couplesPlanText }}</p>
        </div>
        <div
          :data-e2e="BillingCypressAttribute.checkoutSession.views.VAULT_PLAN_PRICE"
          class="has-text-right"
        >
          <p class="is-size-2 has-text-weight-semibold">
            {{ formatPrice(billingPlanForm.price) }}
          </p>
          <div
            v-if="billingPlanForm.chargeRecurringFee"
            :data-e2e="BillingCypressAttribute.checkoutSession.views.VAULT_PLAN_PRICE_RECURRING"
          >
            {{ $t('standardplan.per-year', { price: formatPrice(billingPlanForm.yearlyPrice) }) }}
          </div>
        </div>
      </div>
      <div class="pt-4">{{ billingPlanForm.description }}</div>
    </div>
    <Collapse :open="false" :is-borderless="true" class="px-2 pt-4">
      <template #header>
        <p class="is-size-3 has-text-weight-medium">{{ $t('billing.plan-details') }}</p>
      </template>
      <BillingCardInclusionsExclusions
        :inclusions="billingPlanForm.inclusions"
        :exclusions="billingPlanForm.exclusions"
        class="mt-0"
      />
      <div class="has-background-light has-border-radius my-4 py-5 px-4">
        <p v-dompurify-html="billingPlanForm.legalDisclaimer" />
        <p class="pt-3">* {{ $t('billing.subject-to-annual-fees') }}</p>
      </div>
    </Collapse>
  </div>
</template>
<script>
import pluralize from 'pluralize';
import { BillingCypressAttribute } from '@/modules/billing/constants/BillingCypressAttribute';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';
import BillingCardInclusionsExclusions from '@/modules/estate/components/presentational/BillingCardInclusionsExclusions.vue';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { HasCurrentEstateMixin } from '@/modules/core/app/mixins/HasCurrentEstateMixin';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { ModalCypressAttribute } from '@/modules/core/app/constants/ModalCypressAttribute';
import { SelfServeBillingPlanForm } from '@/modules/estate/models/SelfServeBillingPlanForm';
import Collapse from '/@/modules/core/app/components/Collapse.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'VaultCheckoutSessionCard',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  components: {
    BillingCardInclusionsExclusions,
    Collapse
  },
  props: {
    billingPlanForm: {
      type: SelfServeBillingPlanForm,
      required: true
    }
  },
  static: {
    ProductKey,
    BillingCypressAttribute,
    ModalCypressAttribute
  },
  computed: {
    couplesPlanText() {
      return this.billingPlanForm.isCouplesPlan
        ? this.$t('estate.couple')
        : this.$t('estate.individual');
    }
  },
  methods: {
    pluralize,
    formatPrice(price) {
      return NumeralService.formatValue(price, ColumnFormat.FORMAT_CURRENCY);
    }
  }
};
</script>

<style scoped>
:deep(div.trigger) {
  padding-right: 0;
  padding-left: 0;

  margin-left: var(--ce--6px);
}
</style>
